var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insurance-list"},_vm._l((_vm.data),function(item){return _c('insurance-list-item',_vm._b({key:item.key},'insurance-list-item',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }